<template>
  <label
    class="leading-6"
    :class="[
      small
        ? 'text-xs text-gray-500'
        : 'mb-2 text-sm font-medium text-gray-900',
      labelAction
        ? 'flex items-center justify-between whitespace-nowrap'
        : 'inline-block',
    ]"
  >
    <span class="inline-flex items-center space-x-2">
      <span>
        <slot />
        <span v-if="required" class="text-red-600"> *</span>
      </span>
      <slot name="additional-icon" />
    </span>
    <span
      v-if="labelAction"
      class="clickable-text"
      :class="labelActionClasses"
      @click="emit('labelActionClicked')"
    >
      {{ labelAction }}
    </span>
  </label>
</template>

<script lang="ts" setup>
defineProps({
  labelAction: {
    type: String,
    default: undefined,
  },
  labelActionClasses: {
    type: String,
    default: undefined,
  },
  small: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['labelActionClicked']);
</script>
